import React from 'react';

import { useSelector } from 'react-redux';

import { isBlockingLoadingSelector } from './selector';

import LoadingUI from '@/components/Loading';

const BlockingLoading: React.FC = () => {
  const isLoading = useSelector(isBlockingLoadingSelector);
  if (isLoading) {
    return <LoadingUI />;
  }
  return null;
};

export default BlockingLoading;
